const upperCaseFirstLetter = (text: string) => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

export default upperCaseFirstLetter;
